import { Link } from 'react-router-dom';
import { 
  ArrowRight, Heart, Leaf, Users, Award, Target, 
  ShieldCheck, Globe, Truck, Star, Search, Sprout, Shield
} from 'lucide-react';
import { useStore } from '../admin/context/ProductStore';
import './About.css';

const approachCards = [
  { 
    icon: <Sprout size={32} />, 
    title: 'Chemical-Free Dry Fruits', 
    desc: 'We focus on sourcing high-quality, sustainable products that are free from harmful chemicals and pesticides.' 
  },
  { 
    icon: <Target size={32} />, 
    title: 'Sustainable Sourcing', 
    desc: 'By partnering with local farmers and following organic practices, we ensure a sustainable supply chain for the future.' 
  },
  { 
    icon: <Shield size={32} />, 
    title: 'Chemical-Free Processing', 
    desc: 'Our processing methods are strictly controlled to maintain the natural nutrients without any artificial preservatives.' 
  },
  { 
    icon: <Heart size={32} />, 
    title: 'KOA\'s Commitment', 
    desc: 'We are committed to helping our customers lead better lives through nature\'s most powerful superfoods.' 
  },
];

const founders = [
  { 
    name: 'Dr. Rakesh Kumar Aggarwal', 
    role: 'Ph.D Horticulture (Vegetable Science), Founder & CEO', 
    image: '/rakesh-sir.jpeg' 
  },
];

export default function About() {
  const { siteContent } = useStore();
  const { about, mission } = siteContent;

  return (
    <main className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="container about-hero-inner">
          <div className="about-hero-text anim-fade-up">
            <span className="eyebrow" style={{ color: 'var(--yellow)' }}>{about.eyebrow || 'OUR STORY'}</span>
            <h1 className="about-title">{about.title}</h1>
            <p className="about-lead">
              {about.lead}
            </p>
            <div className="hero-btns">
              <Link to="/shop" className="btn-yellow">
                Shop Our Products <ArrowRight size={16} />
              </Link>
            </div>
          </div>
          <div className="about-hero-img anim-slide-left">
            <img src="/story.png" alt="KOA Story" />
            {/* Circular badges removed as per live site analysis */}
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="section container">
        <div className="mission-grid">
          <div className="mission-content anim-fade-up">
            <span className="eyebrow">{mission.eyebrow}</span>
            <h2 className="section-title">{mission.title}</h2>
            <p className="mission-text">{mission.text1}</p>
            <p className="mission-text">{mission.text2}</p>
          </div>
          <div className="mission-img-wrap anim-fade-up">
            <img src="/mission.png" alt="Our Mission" className="mission-img" />
          </div>
        </div>
      </section>

      {/* Approach (Value Cards) */}
      <section className="section values-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center' }}>
            <span className="eyebrow">WHAT DRIVES US</span>
            <h2 className="section-title">Our KOA Approach</h2>
          </div>
          <div className="values-grid">
            {approachCards.map((v, i) => (
              <div key={i} className="value-card">
                <div className="value-icon">{v.icon}</div>
                <h3 className="value-title">{v.title}</h3>
                <p className="value-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Founders */}
      <section className="section team-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center' }}>
            <span className="eyebrow">Founders</span>
            <h2 className="section-title">The People Behind KOA</h2>
          </div>
          <div className="team-grid">
            {founders.map((m, i) => (
              <div key={i} className="team-card">
                <div className="team-avatar">
                  <img src={m.image} alt={m.name} className="team-img" />
                </div>
                <h3 className="team-name" style={{ fontSize: '20px' }}>{m.name}</h3>
                <p className="team-role" style={{ color: 'var(--text-muted)', fontSize: '14px', textTransform: 'none', letterSpacing: 'normal' }}>
                  {m.role}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta section">
        <div className="container about-cta-inner">
          <h2 className="about-cta-title">Ready to taste the difference?</h2>
          <p className="about-cta-desc">
            Join the community of people who trust KOA for their daily nutrition.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
            <Link to="/shop" className="btn-yellow">Shop Our Products <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
